import type { IPlanKey } from '../types';

import { create } from 'zustand';

interface IDowngradeStoreState {
  currentStep: number;
  downgradePlanKey: IPlanKey | null;
}

interface IDowngradeStoreActions {
  resetStep: () => void;
  nextStep: () => void;
  previousStep: () => void;
  setDowngradePlanKey: (val: IPlanKey) => void;
}
export const useDowngradeStore = create<IDowngradeStoreState & IDowngradeStoreActions>()((set) => ({
  currentStep: 1,
  downgradePlanKey: null,

  resetStep: () => set(() => ({ currentStep: 1 })),
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  previousStep: () => set((state) => ({ currentStep: state.currentStep - 1 })),
  setDowngradePlanKey: (val: IPlanKey) => {
    set(() => ({ downgradePlanKey: val }));
  },
}));
